<div class="logo-box">
  <a routerLink="/" aria-label="logo image"><img src="assets/images/public-dark-logo.png" width="155" alt="img" /></a>
</div>
<!-- /.logo-box -->
<div class="mobile-nav__container">
  <ul class="main-menu__list">

    <li *ngIf="!userProfile || userProfile === null || userProfile.isLoggedIn !== true" class="list-type">
      <a class="custom-mobile-class" (click)="closeMobileMenu()" routerLink="/account/login">{{'login' | translate}}</a>
    </li>

    <li class="dropdown list-type" *ngIf="userProfile && userProfile !== null && userProfile.isLoggedIn === true">
      <a href="javascript:void(0)" class="custom-mobile-class" (click)="closeMobileMenu()">{{'profile' |
        translate}}<span class="nav_arrow"></span></a>
      <ul class="sub-menu">
        <li class="dropdown list-type">
          <a routerLink="/user/userDetails/{{userProfile.id}}" (click)="closeMobileMenu()"
            class="custom-mobile-class">{{'myProfile' |
            translate}}</a>
        </li>
        <li class="dropdown list-type">
          <a routerLink="/order/orders" (click)="closeMobileMenu()" class="custom-mobile-class">{{'myOrders' |
            translate}}</a>
        </li>
        <li class="dropdown list-type">
          <a routerLink="/order/ordersServices" (click)="closeMobileMenu()" class="custom-mobile-class">{{'myServices' |
            translate}}</a>
        </li>
        <li class="dropdown list-type">
          <a href="javascript:(void)" class="custom-mobile-class" (click)="logout()">{{'logout' | translate}}</a>
        </li>
      </ul>
    </li>
    <li class="list-type">
      <a href="javascript:(void)" class="custom-mobile-class"
        (click)="changeLanguage()">{{(lang==='ar'?'englishLanguage' :
        'arabicLanguage') | translate}}</a>
    </li>


  </ul>
</div>

<div class="mobile-nav__container">
  <ul class="main-menu__list">
    <li [ngClass]="item.child == true ? 'dropdown' : ''" *ngFor="let item of navigationArray" class="list-type">
      <a href="javascript:void(0)" (click)="trigger(item)" *ngIf="item.child" class="custom-mobile-class"
        [ngClass]="item.open ? 'expanded' : ''">{{item.linkText | translate}}</a>
      <a routerLink="{{item.link}}" (click)="closeMobileMenu()" *ngIf="!item.child && item.id !==3 && item.id !==4"
        class="custom-mobile-class">{{item.linkText|
        translate}}</a>
      <a (click)="goToDiv('about-us-section')" href="javascript:void(0)" class="custom-mobile-class"
        *ngIf="!item.child && item.id ===3">{{item.linkText| translate}}</a>
      <a (click)="goToDiv('contact-us-section')" href="javascript:void(0)" class="custom-mobile-class"
        *ngIf="!item.child && item.id ===4">{{item.linkText| translate}}</a>
      <ul class="sub-menu" *ngIf="item.child" [ngClass]="item.open ? 'd-block' : ''">
        <li [ngClass]="item.child == true ? 'dropdown' : ''" *ngFor="let item of item.submenu" class="list-type">
          <a href="javascript:void(0)" (click)="trigger(item)" *ngIf="item.child" class="custom-mobile-class"
            [ngClass]="item.open ? 'expanded' : ''">{{item.linkText | translate}} </a>
          <a routerLink="{{item.link}}" (click)="closeMobileMenu()" *ngIf="!item.child"
            class="custom-mobile-class">{{item.linkText |
            translate}}</a>
          <ul class="sub-menu" *ngIf="item.child" [ngClass]="item.open ? 'd-block' : ''">
            <li *ngFor="let item of item.submenu" class="list-type">
              <a routerLink="{{item.link}}" class="custom-mobile-class">{{item.linkText | translate}}</a>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</div>




<!-- /.mobile-nav__container -->
<ul class="mobile-nav__contact list-unstyled">
  <li>
    <i class="icon-letter"></i>
    <a href="mailto:information@tableegh.ae">information@tableegh.ae</a>
  </li>
  <li>
    <i class="icon-phone-call"></i>
    <a href="tel:0097143949444" class="text-dir-ltr">+971 4 3949444</a>
  </li>
</ul><!-- /.mobile-nav__contact -->
<div class="mobile-nav__top">
  <div class="mobile-nav__social">
    <a href="https://twitter.com" target="_blank" class="fab fa-twitter"></a>
    <a href="https://facebook.com" target="_blank" class="fab fa-facebook-square"></a>
    <a href="https://linkedin.com" target="_blank" class="fab fa-linkedin"></a>
    <a href="https://instagram.com" target="_blank" class="fab fa-instagram"></a>
  </div><!-- /.mobile-nav__social -->
</div><!-- /.mobile-nav__top -->
